// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ForkOnboarding_modalFooter__1Zn1U","description":"ForkOnboarding_description__ElKaV"};